<birdz-modal>
  <div modal-body class="body">
    <div class="chart-title">
      {{ 'KPI_DETAILS.PDS_KPI_HISTORY.TITLE' | transloco: { kpi: data.kpiLabel, pds: data.pdsCustomerId } }}
    </div>
    @if (isLoading) {
      <div class="spinner-wrapper">
        <mat-spinner [diameter]="40" />
      </div>
    } @else {
      <highcharts-chart [options]="chartOptions!" style="display: block; height: 350px" />
    }
  </div>
</birdz-modal>
